export enum LUMAPPS_APPLICATIONS {
    /**
     * @value Access settings
     */
    ACCESS_SETTINGS = 'LUMAPPS_APPLICATIONS.ACCESS_SETTINGS',
    /**
     * @value Additional attributes
     */
    ADDITIONAL_ATTRIBUTES = 'LUMAPPS_APPLICATIONS.ADDITIONAL_ATTRIBUTES',
    /**
     * @value Add pair
     */
    ADD_ATTRIBUTE_PAIR = 'LUMAPPS_APPLICATIONS.ADD_ATTRIBUTE_PAIR',
    /**
     * @value Allowed users
     */
    ALLOWED_USERS = 'LUMAPPS_APPLICATIONS.ALLOWED_USERS',
    /**
     * @value Application created successfully.
     */
    APPLICATION_CREATED = 'LUMAPPS_APPLICATIONS.APPLICATION_CREATED',
    /**
     * @value Failed to save changes. Please try again.
     */
    APPLICATION_CREATE_ERROR = 'LUMAPPS_APPLICATIONS.APPLICATION_CREATE_ERROR',
    /**
     * @value Application deleted
     */
    APPLICATION_DELETED = 'LUMAPPS_APPLICATIONS.APPLICATION_DELETED',
    /**
     * @value Application ID
     */
    APPLICATION_ID = 'ASK_AI_SOURCES.VERTEX_AI_APPLICATION_ID',
    /**
     * @value Application ID copied to clipboard
     */
    APPLICATION_ID_COPIED = 'LUMAPPS_APPLICATIONS.APPLICATION_ID_COPIED',
    /**
     * @value Application secret
     */
    APPLICATION_SECRET = 'LUMAPPS_APPLICATIONS.APPLICATION_SECRET',
    /**
     * @value Application type
     */
    APPLICATION_TYPE = 'LUMAPPS_APPLICATIONS.APPLICATION_TYPE',
    /**
     * @value Application settings updated
     */
    APPLICATION_UPDATED = 'LUMAPPS_APPLICATIONS.APPLICATION_UPDATED',
    /**
     * @value This attribute name is reserved and cannot be used.
     */
    ATTRIBUTE_NAME_BLOCKED = 'LUMAPPS_APPLICATIONS.ATTRIBUTE_NAME_BLOCKED',
    /**
     * @value This attribute name is already used.
     */
    ATTRIBUTE_NAME_DUPLICATED = 'LUMAPPS_APPLICATIONS.ATTRIBUTE_NAME_DUPLICATED',
    /**
     * @value Audience already in use by another client. Choose another.
     */
    AUDIENCE_ALREADY_IN_USE = 'LUMAPPS_APPLICATIONS.AUDIENCE_ALREADY_IN_USE',
    /**
     * @value Define audience
     */
    AUDIENCE_PLACEHOLDER = 'LUMAPPS_APPLICATIONS.AUDIENCE_PLACEHOLDER',
    /**
     * @value Authorization code (MCP)
     */
    AUTHORIZATION_CODE_MCP = 'LUMAPPS_APPLICATIONS.AUTHORIZATION_CODE_MCP',
    /**
     * @value <strong>Copy the application secret and save it securely before closing this window,</strong> as it is only displayed once.
     */
    AUTHORIZATION_CODE_SUMMARY_INFO_BANNER = 'LUMAPPS_APPLICATIONS.AUTHORIZATION_CODE_SUMMARY_INFO_BANNER',
    AUTHORIZATION_CODE_SUMMARY_SECRET_WARNING = 'LUMAPPS_APPLICATIONS.AUTHORIZATION_CODE_SUMMARY_SECRET_WARNING',
    /**
     * @value Client credentials
     */
    CLIENT_CREDENTIALS = 'CONNECTORS.CLIENT_CREDENTIALS_NEW',
    /**
     * @value Copy Application ID
     */
    COPY_APPLICATION_ID = 'LUMAPPS_APPLICATIONS.COPY_APPLICATION_ID',
    /**
     * @value Copy Application secret
     */
    COPY_APPLICATION_SECRET = 'LUMAPPS_APPLICATIONS.COPY_APPLICATION_SECRET',
    /**
     * @value Copy audience
     */
    COPY_IDENTITY_AUDIENCE = 'LUMAPPS_APPLICATIONS.COPY_IDENTITY_AUDIENCE',
    /**
     * @value Default user to impersonate
     */
    DEFAULT_USER_TO_IMPERSONATE = 'LUMAPPS_APPLICATIONS.DEFAULT_USER_TO_IMPERSONATE',
    /**
     * @value The application will impersonate this user by default
     */
    DEFAULT_USER_TO_IMPERSONATE_HELPER = 'LUMAPPS_APPLICATIONS.DEFAULT_USER_TO_IMPERSONATE_HELPER',
    /**
     * @value Deleting %ITEM_NAME% application is irreversible. This action may make some integration features unavailable.
     */
    DELETE_CONFIRM_DESCRIPTION = 'LUMAPPS_APPLICATIONS.DELETE_CONFIRM_DESCRIPTION',
    /**
     * @value Delete application?
     */
    DELETE_CONFIRM_TITLE = 'LUMAPPS_APPLICATIONS.DELETE_CONFIRM_TITLE',
    /**
     * @value Could not delete application, try again
     */
    DELETE_ERROR = 'LUMAPPS_APPLICATIONS.DELETE_ERROR',
    /**
     * @value Updating %APPLICATION_NAME% may make some integration features unavailable.
     */
    EDIT_AC_CONFIRM_DESCRIPTION = 'LUMAPPS_APPLICATIONS.EDIT_AC_CONFIRM_DESCRIPTION',
    /**
     * @value Update application?
     */
    EDIT_AC_CONFIRM_TITLE = 'LUMAPPS_APPLICATIONS.EDIT_AC_CONFIRM_TITLE',
    /**
     * @value Edit LumApps Identity %APPLICATION_NAME%
     */
    EDIT_LUMAPPS_IDENTITY_TITLE = 'LUMAPPS_APPLICATIONS.EDIT_LUMAPPS_IDENTITY_TITLE',
    /**
     * @value LumApps Identity
     */
    LUMAPPS_IDENTITY = 'ADMIN.CUSTOMER.IDENTITY_PROVIDER_INTERNAL',
    /**
     * @value LumApps Applications
     */
    NAME = 'LUMAPPS_APPLICATIONS.NAME',
    /**
     * @value New application
     */
    NEW_APPLICATION = 'LUMAPPS_APPLICATIONS.NEW_APPLICATION',
    /**
     * @value No Application yet
     */
    NO_APPLICATION_YET = 'LUMAPPS_APPLICATIONS.NO_APPLICATION_YET',
    /**
     * @value Profile fields from platform
     */
    PROFILE_FIELDS_FROM_PLATFORM = 'LUMAPPS_APPLICATIONS.PROFILE_FIELDS_FROM_PLATFORM',
    /**
     * @value Select profile fields
     */
    PROFILE_FIELDS_PLACEHOLDER = 'LUMAPPS_APPLICATIONS.PROFILE_FIELDS_PLACEHOLDER',
    /**
     * @value Employee ID
     */
    PROFILE_FIELD_EMPLOYEE_ID = 'LUMAPPS_APPLICATIONS.PROFILE_FIELD_EMPLOYEE_ID',
    /**
     * @value Enter a valid URL starting with https://.
     */
    REDIRECT_URL_HTTPS_REQUIRED = 'LUMAPPS_APPLICATIONS.REDIRECT_URL_HTTPS_REQUIRED',
    /**
     * @value Enter a valid URL starting with https://. Localhost links are not allowed.
     */
    REDIRECT_URL_INVALID = 'LUMAPPS_APPLICATIONS.REDIRECT_URL_INVALID',
    /**
     * @value Using http://localhost as a redirect URL is unsafe.
     */
    REDIRECT_URL_LOCALHOST_WARNING = 'LUMAPPS_APPLICATIONS.REDIRECT_URL_LOCALHOST_WARNING',
    /**
     * @value Require PKCE
     */
    REQUIRE_PKCE = 'LUMAPPS_APPLICATIONS.REQUIRE_PKCE',
    /**
     * @value Enforce PKCE (Proof Key for Code Exchange) to protect the authorization code flow against interception. Disable only if your integration does not support it.
     */
    REQUIRE_PKCE_HELPER = 'LUMAPPS_APPLICATIONS.REQUIRE_PKCE_HELPER',
    /**
     * @value Restricted Impersonation List
     */
    RESTRICTED_IMPERSONATION_LIST = 'LUMAPPS_APPLICATIONS.RESTRICTED_IMPERSONATION_LIST',
    /**
     * @value By default, the application impersonates all users. Add specific user IDs to restrict this access.
     */
    RESTRICTED_IMPERSONATION_LIST_DESCRIPTION = 'LUMAPPS_APPLICATIONS.RESTRICTED_IMPERSONATION_LIST_DESCRIPTION',
    /**
     * @value I have safely stored this secret.
     */
    SECRET_STORED_CONFIRMATION = 'LUMAPPS_APPLICATIONS.SECRET_STORED_CONFIRMATION',
    /**
     * @value We store the Client ID for future reference. Use Audience in token exchange endpoint to reach this configuration.
     */
    SUMMARY_INFO_BANNER = 'LUMAPPS_APPLICATIONS.SUMMARY_INFO_BANNER',
    /**
     * @value Store this information before closing this window.
     */
    SUMMARY_STORE_WARNING = 'LUMAPPS_APPLICATIONS.SUMMARY_STORE_WARNING',
    /**
     * @value An error occurred while updating the application
     */
    UPDATE_ERROR = 'LUMAPPS_APPLICATIONS.UPDATE_ERROR',
    /**
     * @value Date of birth
     * @description date of birth
     */
    DATE_OF_BIRTH = 'LUMAPPS_APPLICATIONS.DATE_OF_BIRTH',
}
